import React from 'react';

interface SRErrorNoticeProps {
  code: string;
  message: string;
  variant?: 'error' | 'warning';
}

export const SRErrorNotice: React.FC<SRErrorNoticeProps> = ({
  code,
  message,
  variant = 'error',
}) => (
  <div className={`admin-notice admin-notice--${variant}`} role="alert">
    {message}{' '}
    <span className="sr-error-code">Code: {code}</span>
  </div>
);
